// assets/announcement-bar.js
//
// Standalone custom element for the header's announcement bar. Only handles the optional close button --
// the marquee scroll itself is pure CSS (see assets/announcement-bar.css) so it keeps animating even if this
// script fails to load. Dismissal is remembered for the browser session via sessionStorage, keyed by section id.

class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this._storageKey = `announcement-bar-closed:${this.id}`;

    if (sessionStorage.getItem(this._storageKey) === "true") {
      this.classList.add("is-closed");
    }

    this._closeButton = this.querySelector("[data-announcement-close]");
    if (this._closeButton) {
      this._onCloseListener = this._onClose.bind(this);
      this._closeButton.addEventListener("click", this._onCloseListener);
    }
  }

  disconnectedCallback() {
    if (this._closeButton) {
      this._closeButton.removeEventListener("click", this._onCloseListener);
    }
  }

  _onClose() {
    this.classList.add("is-closed");
    sessionStorage.setItem(this._storageKey, "true");
  }
}

customElements.define("announcement-bar", AnnouncementBar);
